<template>
  <div ref="containerRef" class="timeline-container">
    <div class="carousel-wrapper">
      <!-- Arrows -->
      <button
        class="carousel-button left"
        @click="prevSlide"
        v-if="currentIndex > 0"
        aria-label="Previous"
      >‹</button>
      <button
        class="carousel-button right"
        @click="nextSlide"
        v-if="currentIndex < hotels.length - 1"
        aria-label="Next"
      >›</button>

      <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div
          v-for="(hotel, index) in hotels"
          :key="index"
          class="hotel-card"
          :ref="el => setHotelCard(el, index)"
        >
          <!-- 🌟 FLORES DECORATIVAS EN LAS ESQUINAS -->
          <img src="@/assets/fl.png" class="flor-hotel flor-top-left" alt="" />
          <img src="@/assets/fl.png" class="flor-hotel flor-bottom-right" alt="" />

          <p class="recomendacion-hospedaje" :ref="el => setRefs(el, index, 'titulo')">{{ hotel.titulo }}</p>
          <p :ref="el => setRefs(el, index, 'descripcion')">{{ hotel.descripcion }}</p>
          <img
            :src="hotel.imagen"
            :alt="hotel.nombre"
            class="hotel-image rounded-circle"
            :ref="el => setRefs(el, index, 'imagen')"
          />
          <div class="hotel-info" :ref="el => setRefs(el, index, 'info')">
            <h3>{{ hotel.nombre }}</h3>
            <strong>Dirección:</strong><br />
            <p v-html="hotel.direccion"></p>
            <p><i class="fas fa-phone" /> {{ hotel.telefono }}</p>
            <a
              :href="hotel.ubicacion"
              class="modern-button"
              target="_blank"
              rel="noopener noreferrer"
              :ref="el => setRefs(el, index, 'boton')"
            >
              Ubicación <i class="fas fa-map-marker-alt" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';

import hotel1Img from '@/assets/holiday.webp';
import hotel2Img from '@/assets/court.jpeg';
import hotel3Img from '@/assets/480774027.jpg';


export default {
  name: 'HospedajeVue',
  setup() {
    const containerRef = ref(null);
    const hotelCards = ref([]);
    const refsMap = ref([]); // refsMap[index] = { titulo, descripcion, imagen, info, boton }
    const currentIndex = ref(0);

   const hotels = [
  {
    titulo: 'Hospedaje.',
    descripcion: 'Recomendación.',
    nombre: 'Courtyard by Marriott Mexicali',
    imagen: hotel2Img,
    direccion: 'Calzada Cetys 2650, Residencial Veredas del Sol, Mexicali, B.C.',
    telefono: '+52 686 218 01 69',
    ubicacion: 'https://maps.app.goo.gl/Ru59e9vQC2TeuwsD7'
  },
  {
    titulo: 'Hospedaje.',
    descripcion: 'Otra excelente opción.',
    nombre: 'Holiday Inn Express & Suites Mexicali by IHG',
    imagen: hotel1Img,
    direccion: 'Calzada Lic, Manuel Gómez Morín 855-Interior Col, Rivera,  Mexicali, B.C.',
    telefono: '+52 686 21 80 169',
    ubicacion: 'https://maps.app.goo.gl/cRgHxBdLiMyPtvFa8'
  },

  {
    titulo: 'Hospedaje.',
    descripcion: 'Otra excelente opción.',
    nombre: 'Fairfield by Marriott Inn & Suites Mexicali',
    imagen: hotel3Img,
    direccion: 'Calz. Manuel Gómez Morín 856, Rivera,  Mexicali, B.C',
    telefono: '+52 686 200 01 50',
    ubicacion: 'https://maps.app.goo.gl/5my7ZcL2UdgsPGcX7'
  },
 
];


    const setHotelCard = (el, index) => {
      if (el) hotelCards.value[index] = el;
    };

    const setRefs = (el, index, key) => {
      if (!refsMap.value[index]) refsMap.value[index] = {};
      refsMap.value[index][key] = el;
    };

    const animateElements = (elements, cardEl) => {
      if (!elements) return;

      // Animaciones de los contenidos principales
      gsap.fromTo(elements.titulo, { x: -50, opacity: 0 }, { x: 0, opacity: 1, duration: 0.6 });
      gsap.fromTo(elements.descripcion, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 0.6, delay: 0.2 });
      gsap.fromTo(elements.imagen, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, delay: 0.4 });
      gsap.fromTo(elements.info, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6, delay: 0.6 });
      gsap.fromTo(elements.boton, { scale: 0.8, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.6, delay: 0.8 });

      // 🌟 Animación de entrada padrisima para las flores de esta tarjeta
      if (cardEl) {
        const flores = cardEl.querySelectorAll('.flor-hotel');
        gsap.fromTo(flores, 
          { opacity: 0, scale: 0.5, rotation: (i) => i === 0 ? -45 : 45 },
          { opacity: 1, scale: 1, rotation: 0, duration: 1, delay: 0.3, ease: 'back.out(1.7)' }
        );
      }
    };

    const prevSlide = () => {
      if (currentIndex.value > 0) {
        currentIndex.value--;
        nextTick(() => animateElements(refsMap.value[currentIndex.value], hotelCards.value[currentIndex.value]));
      }
    };

    const nextSlide = () => {
      if (currentIndex.value < hotels.length - 1) {
        currentIndex.value++;
        nextTick(() => animateElements(refsMap.value[currentIndex.value], hotelCards.value[currentIndex.value]));
      }
    };

    onMounted(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = hotelCards.value.findIndex(el => el === entry.target);
            if (index !== -1) {
              animateElements(refsMap.value[index], entry.target);
              observer.unobserve(entry.target);
            }
          }
        });
      }, { threshold: 0.3 });

      hotelCards.value.forEach(card => {
        if (card) {
          observer.observe(card);

          // 🌟 Animación de respiración orgánica sutil y flotado para todas las flores
          const flores = card.querySelectorAll('.flor-hotel');
          gsap.to(flores, {
            y: '+=8',
            rotation: '+=4',
            duration: 3,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut',
            stagger: 0.5
          });
        }
      });
    });

    return {
      containerRef,
      hotelCards,
      hotels,
      currentIndex,
      prevSlide,
      nextSlide,
      setHotelCard,
      setRefs
    };
  }
};
</script>

<style scoped>
.timeline-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 95vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.carousel-wrapper {
  position: relative;
  width: 80%;
  overflow: hidden;
}

.carousel {
  display: flex;
  transition: transform 0.6s ease;
}

.hotel-card {
  position: relative; /* Necesario para posicionar las flores */
  width: 100%;
  max-width: 500px;
  flex-shrink: 0;
  text-align: center;
  padding: 80px 20px;
  margin: 0 auto;
  border-radius: 0 80px 0 80px;
 background:
    linear-gradient(
       rgba(18, 5, 50, 0.941),
      rgb(61, 46, 85)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;
  transition: transform 0.3s ease;
  overflow: visible; /* Permite que las flores sobresalgan sutilmente si es necesario */
}

.hotel-card:hover {
  transform: scale(1.05);
}

/* 🌟 ESTILOS DE LAS FLORES EN LAS ESQUINAS */
.flor-hotel {
  position: absolute;
  width: min(25vw, 100px);
  height: auto;
  pointer-events: none;
  z-index: 5;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.15));
}

.flor-top-left {
  top: -15px;
  left: -5px;
}

.flor-bottom-right {
  bottom: -15px;
  right: -15px;
  transform: scaleX(-1); /* Espejo para la esquina inferior */
}

.hotel-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 20px;
}

.hotel-info {
  font-family: 'Josefin Sans', sans-serif;
  color: rgba(238, 243, 236, 0.9);
}

.hotel-info h3 {
  font-size: 18px;
  color: #e6dede;
}

.hotel-card p {
  font-size: 16px;
  color: #e8e3e3;
}

.recomendacion-hospedaje {
  font-family: 'verde';
  font-size: 34px !important;
  margin-bottom: 12px;
  color: #ebf0e9d7 !important;
}

.modern-button {
  display: inline-block;
  text-decoration: none;
  background: #ffffff;
  color: #333;
  padding: 8px 18px;
  font-family: 'padres';
  font-weight: bold;
  border: none;
  border-radius: 25px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, background 0.5s ease;
  margin-bottom: 15px;
}

.carousel-button {
  position: absolute;
  top: 50%;
  background: #f1efef;
  color: #333;
  width: 44px;
  height: 44px;
  font-size: 28px;
  font-family: 'Arial';
  font-weight: bold;
  z-index: 10;
  cursor: pointer;
  transform: translateY(-50%);
  transition: transform 0.3s ease, opacity 0.3s ease;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-button.left {
  left: 10px;
  animation: moveLeft 1s infinite ease-in-out;
}

.carousel-button.right {
  right: 10px;
  animation: moveRight 1s infinite ease-in-out;
}

.carousel-button:hover {
  transform: scale(1.3) translateY(-50%);
  opacity: 1;
}

@keyframes moveLeft {
  0%, 100% { transform: translateX(0); opacity: 1; }
  50% { transform: translateX(-10px); opacity: 0.6; }
}

@keyframes moveRight {
  0%, 100% { transform: translateX(0); opacity: 1; }
  50% { transform: translateX(10px); opacity: 0.6; }
}
</style>